// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"0efe4a13","598":"2c72d946","787":"4fa21437"}[chunkId] + ".chunk.js";
};